



















































































































































































// vue
import { Component, Vue } from 'vue-property-decorator'

// componnents
import { PageHeader, ButtonExport, AccordionFilters } from '@/components'
import { Select2, DatePicker } from '@/components/general'
import { TableListAsistances, ModalImportAssistance } from '@/components/assistance'

// services
import { AssistanceService } from '@/services/assistance'
import { EmployeeService, HeadquarterService, AreaService, SubAreaService } from '@/services/config'

// utils
import { loading, alerts, getFullNameFormat } from '@/utils'
import { getTextDocumentType } from '@/constants'

// models
import { AssistanceForm, AssistanceModel, FiltersAssistance } from '@/models/assistance'
import { BvModalEvent } from 'bootstrap-vue'
import { EmployeeModel, HeadquarterModel, AreaModel, SubAreaModel } from '@/models/config'
// views
import ModalCreateEditAssistance from './modalCreateEdit.vue'
import { PropOptionSelect } from '@/models'

const newItem: AssistanceForm = {
  checkin_time: '',
  checkout_time: '',
  employee_id: null,
  date: null,
  absence: false,
  reason_absence: null
}

@Component({
  name: 'AssistancesIndex',
  components: {
    PageHeader,
    TableListAsistances,
    ModalCreateEditAssistance,
    ModalImportAssistance,
    ButtonExport,
    Select2,
    DatePicker,
    AccordionFilters
  }
})
export default class AssistancesIndex extends Vue {
  showModal = false
  showVideoTutorial = false
  showModalImport = false
  showModalImportDevice = false
  typeImport = 'device'
  assistance: AssistanceForm = newItem
  title = 'Asistencia'
  actionForm = 'save'
  idItemEdit: number|null = null
  typeItemEdit = ''
  items = [
    {
      text: 'Dashboard',
      to: { name: 'home' }
    },
    {
      text: 'Asistencia',
      active: true
    }
  ]

  headersExcel = [
    { text: 'Documento', value: 'document_number' },
    { text: 'Tipo Documento', value: 'document_type' },
    { text: 'Apellido Paterno', value: 'last_name' },
    { text: 'Apellido Materno', value: 'mothers_last_name' },
    { text: 'Nombre', value: 'name' },
    { text: 'Área', value: 'area' },
    { text: 'Sub Área', value: 'subarea' },
    { text: 'Fecha', value: 'date' },
    { text: 'Hora de Inicio', value: 'checkin_time' },
    { text: 'Hora de Salida', value: 'checkout_time' },
    { text: 'Inasistencia', value: 'absence' },
    { text: 'Motivo', value: 'reason_text' },
    { text: 'Creado Por', value: 'userCreation' },
    { text: 'Tipo de Registro', value: 'type_text' }
  ]

  filters: FiltersAssistance = {
    employeeId: null,
    dateStart: null,
    dateEnd: null,
    headquartersId: null,
    areaId: null,
    subareaId: null
  }

  allHeadquarters: HeadquarterModel[] = []
  allAsisstance: AssistanceModel[] = []
  allEmployees: EmployeeModel [] = []
  allAreas: AreaModel [] = []
  allSubareas: SubAreaModel [] = []

  get itemsExcel () {
    return this.allAsisstance.map(item => {
      return {
        ...item,
        ...item.employee,
        document_type: getTextDocumentType(Number(item.employee.document_type)),
        absence: item.absence ? 'SI' : 'NO',
        userCreation: item.userCreation.name,
        area: item.employee.assignment.area?.name,
        subarea: item.employee.assignment.sub_area?.name
      }
    })
  }

  async getAllitems () {
    this.allAsisstance = await AssistanceService.getAll(this.filters)
  }

  filterData () {
    this.tableList.getAssistancesWithPagination()
  }

  cleanFilters () {
    this.filters.employeeId = null
    this.filters.dateStart = null
    this.filters.dateEnd = null
    this.filters.areaId = null
    this.filters.subareaId = null
  }

  async mounted () {
    this.allEmployees = await EmployeeService.getAll()
    this.allHeadquarters = await HeadquarterService.getAllActivate()
    this.allAreas = await AreaService.getActivated()
    this.allSubareas = await SubAreaService.getActivated()
  }

  get listEmployees (): PropOptionSelect[] {
    if (this.filters.headquartersId) {
      return this.allEmployees.filter(employee => Number(employee.assignment.headquarter_id) === Number(this.filters.headquartersId)).map(employee => {
        return {
          value: Number(employee.id),
          text: getFullNameFormat(employee)
        }
      })
    } else {
      return this.allEmployees.map(employee => {
        return {
          value: Number(employee.id),
          text: getFullNameFormat(employee)
        }
      })
    }
  }

  get listHeadquarters (): PropOptionSelect[] {
    return this.allHeadquarters.map(item => {
      return {
        value: Number(item.id),
        text: item.name
      }
    })
  }

  get listAreas (): PropOptionSelect[] {
    return this.allAreas.map(item => {
      return {
        value: Number(item.id),
        text: item.name
      }
    })
  }

  get listSubareas (): PropOptionSelect[] {
    if (this.filters.areaId) {
      return this.allSubareas.filter(subarea => Number(subarea.area_id) === Number(this.filters.areaId)).map(subarea => {
        return {
          value: Number(subarea.id),
          text: subarea.name
        }
      })
    } else {
      return this.allSubareas.map(item => {
        return {
          value: Number(item.id),
          text: item.name
        }
      })
    }
  }

  hideModal (event: BvModalEvent) {
    if (event.trigger !== 'ok') {
      this.showModal = false
    }
  }

  addNew () {
    this.idItemEdit = null
    this.actionForm = 'save'
    this.assistance = newItem
    this.showModal = true
  }

  importAssists (type: string) {
    this.typeImport = type
    this.showModalImport = true
  }

  editItem (item: AssistanceModel) {
    this.assistance = {
      checkin_time: item.checkin_time,
      checkout_time: item.checkout_time,
      employee_id: item.employee_id,
      date: item.date,
      absence: item.absence,
      reason_absence: item.reason_absence
    }
    if (item.id) {
      this.idItemEdit = Number(item.id)
    }
    this.typeItemEdit = item.type_text
    this.actionForm = 'update'
    this.showModal = true
  }

  async deleteItem (item: AssistanceModel) {
    const msg = `Seguro que desea eliminar la asistencia de fecha: ${item.date} del trabajador ${item?.employee?.name || '---'}`
    const confirm = await alerts.confirm(msg)
    if (confirm && item.id) {
      loading('show')
      await AssistanceService.delete(item.id)
      alerts.success()
      this.tableList.getAssistancesWithPagination()
      loading('hide')
    }
  }

  get tableList (): Vue & { getAssistancesWithPagination: () => void } {
    return this.$refs.table_list as Vue & { getAssistancesWithPagination: () => void }
  }

  get itemInit (): AssistanceForm {
    return newItem
  }
}
